import { BoxProps, Box } from '@rebass/grid';
import React from 'react';

const InfoContent = (props: BoxProps) => <Box width={1} pl={[null, null, '31.2rem']} {...props} />;

export default InfoContent;
